'use client';

import LocationListScreen from 'reservations/account/components/LocationListScreen';
import PageLoadSpinner from 'reservations/base/components/PageLoadSpinner';
import useIsLoading from 'reservations/base/hooks/useIsLoading';

function LocationList() {
  const isPageLoading = useIsLoading();

  if (isPageLoading) {
    return <PageLoadSpinner isLoading message="Loading locations..." />;
  }
  return <LocationListScreen />;
}

export default LocationList;
